class AddToCartModal {
    modal: HTMLElement | null;
    constructor(selector: string) {
        this.modal = document.querySelector(selector);
        this.init();
    }

    init() {
        if (!this.modal) return;

        document.body.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.hideModal();
            }
        })

        document.body.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            if (target?.dataset?.closeModal === 'true') {
                this.hideModal();
            }
        })
    }

    showModal() { 
        if(!this.modal?.parentElement) return;
        this.modal.parentElement.style.display = 'flex';
        document.body.classList.add('add-to-cart-modal-open');
    }
    hideModal() { 
        if(!this.modal?.parentElement) return;
        this.modal.parentElement.style.display = 'none';
        this.modal.innerHTML = '';
        document.body.classList.remove('add-to-cart-modal-open');
    }
}

export default AddToCartModal;